import { DatalocalService } from "../../../../shared/services/dataLocal/datalocal.service";
import { MenuService } from './../services/menu/menu.service';
import { Module } from './../services/menu/responses/menu.response';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-menu',
  templateUrl: './page-menu.component.html',
  styleUrls: ['./page-menu.component.scss']
})
export class PageMenuComponent implements OnInit {
  modules: Module[] = [];
  loading = true;

  constructor(private menuService: MenuService, private dataLocalService: DatalocalService) {}

  async ngOnInit(): Promise<void> {
    this.loading = true;
    let response = await this.dataLocalService.obtenerItem('menu');
    if (!response) {
      const resp = await this.menuService.menu().toPromise();
      this.modules = resp.data;
      this.dataLocalService.guardarItem('menu', response);
      // console.log('modules: ', this.modules);
    } else {
      this.modules = response;
    }
    this.loading = false;
  }
}
